import React from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import useAuth from "../../hooks/useAuth";
import { axiosPrivate } from "../../api/PrivateRequestServices";
import Spinner from "../UI/Spinner";
const OtpVerify = ({ setPage, phoneNo }) => {
  const { auth, setAuth } = useAuth();
  const [counter, setCounter] = useState(30);
  const [userOtp, setUserOtp] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isResendOtp, setIsResendOtp] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";
  const userRef = useRef();
  let isvalidOTP = true;
  const [isRequested, setIsRequested] = useState(true);
  useEffect(() => {
    if (counter > 0) {
      setTimeout(() => {
        setCounter((prev) => prev > 0 && prev - 1);
      }, 1000);
    } else {
    }
  }, [counter]);

  const resendOtp = async () => {
    setIsLoading(true);
    setError("");
    let pattern = /^\d{4}$/;
    const value = userOtp;
    if (value) {
      if (!pattern.test(value)) {
        setIsLoading(false);
        setError("Invalid OTP");
        isvalidOTP = false;
      } else {
        setError("");
        isvalidOTP = true;
      }
    }
    setIsResendOtp(true);
    const request = {
      comm_value: phoneNo,
      object_type: "delete_user_request",
    };
    if (isvalidOTP == true) {
      const url = process.env.REACT_APP_SEND_OTP_NEW;
      const res = await axiosPrivate.post(url, request);
      setIsLoading(false);
      if (res?.data?.status === 200) {
        setIsLoading(false);
        setCounter(30);
        setIsResendOtp(true);
      } else {
        setIsLoading(false);
        setIsResendOtp(false);
      }
    }
  };

  const onSubmit = async (e) => {
    setIsLoading(true);
    const request = {
      comm_value: auth?.phone,
      object_type: "delete_user_request",
      otp: userOtp,
    };
    let pattern = /^\d{4}$/;
    const value = userOtp;
    if (!pattern.test(value)) {
      setIsLoading(false);
      setError("Invalid OTP");
      isvalidOTP = false;
    } else {
      setError("");
      isvalidOTP = true;
    }
    if (isvalidOTP === true && userOtp != "" && isRequested) {
      setIsRequested(false);
      const url = process.env.REACT_APP_VERIFY_OTP_NEW;
      const res = await axiosPrivate.post(url, request);
      setIsLoading(true);
      if (res?.data?.status != 200) {
        setIsLoading(false);
        setError(res?.data?.message);
        setIsRequested(true);
        setIsResendOtp(true);
      } else {
        if (res?.data?.response?.data?.otp_verified == 1) {
          setIsLoading(false);
          setPage(2);
          setAuth((prev) => {
            return {
              ...prev,
              accessToken: res?.response?.data?.access_token,
              otpRequired: false,
              userId: res?.response?.data?.user_id,
              isLoggedIn: true,
              userName: res?.response?.data?.name,
              userEmail: res?.response?.data?.email,
              userImage: res?.response?.data?.user_image,
            };
          });
        } else {
          setError(res?.response?.error?.message);
          setIsLoading(false);
        }
      }
    }
  };
  return (
    <>
      {isLoading && <Spinner />}
      <h5>
        {/* <span
          className="material-symbols-rounded mt-s grey mt-4 mr-16 fill"
          onClick={() => {
            setPage(0);
          }}
        >
          arrow_back_ios
        </span> */}
        Enter OTP Sent to {auth?.phone}
      </h5>
      <div className="form">
        <span className={error ? "error" : ""}>
          <input
            required
            onChange={(e) => {
              setUserOtp(e.target.value);
              setError("");
            }}
            type="text"
            placeholder="Enter 4 digit OTP"
            maxLength={4}
            minLength={4}
          />
        </span>

        <div class="formTxt">
          {counter > 0 && (
            <span>
              Resend OTP in <b>{counter}</b>
            </span>
          )}
          {isResendOtp && counter == 0 && (
            <Link
              onClick={resendOtp}
              style={{
                pointerEvents: counter == 0 ? "" : "none",
                padding: "5px",
              }}
            >
              Resend OTP
            </Link>
          )}
        </div>

        {error && (
          <div class="alertTxt">
            <span class="error">
              <i class="material-symbols-rounded fill mt-s error mr-4">error</i>
              {error}
            </span>
          </div>
        )}

        <div class="actionButtons">
          <button onClick={onSubmit} class="btn btnError fullW">
            Delete my account now
          </button>
        </div>
      </div>
    </>
  );
};

export default OtpVerify;
